import styled from 'styled-components'
import React from 'react'
import { Text, getPaletteColor } from 'pcln-design-system'
import PropTypes from 'prop-types'

const CodeShareText = styled(Text.p)`
  padding: 8px 12px;
  color: ${getPaletteColor('text.light')};
  margin-bottom: 0;
  font-size: 10px;
  padding-bottom: ${(props) => (props.isSubjectToGovtApproval ? '0' : '8px')};

  ${(props) => props.theme.flyQueries.desktop} {
    padding: 8px 16px;
    padding-bottom: ${(props) => (props.isSubjectToGovtApproval ? '0' : '8px')};
  }
`

export default function OperatedBy(props) {
  const operatedByAirlines = props.operatedByAirlines
  const validOperatedAirlines = operatedByAirlines && operatedByAirlines.length
  if (!validOperatedAirlines) {
    return null
  }

  const airlineTextArray = operatedByAirlines.map((operator) => operator.airline)
  const airlineText = Array.from(new Set(airlineTextArray)).join(', ') // remove dupes

  return (
    <CodeShareText regular data-test='operated-by' isSubjectToGovtApproval={props.isSubjectToGovtApproval}>
      Operated by {airlineText}
    </CodeShareText>
  )
}

OperatedBy.propTypes = {
  operatedByAirlines: PropTypes.array.isRequired,
  isSubjectToGovtApproval: PropTypes.bool.isRequired,
}

OperatedBy.contextTypes = {
  SETI: PropTypes.object,
}
